import api from './api'

/**
 * Iframe Domain Service
 * Quản lý domains được phép nhúng map qua iframe
 */
const iframeDomainService = {
  // ============================================================
  // ADMIN CRUD
  // ============================================================

  /**
   * Lấy danh sách domains (admin)
   * @param {Object} params - { page, per_page, status, search }
   */
  async getDomains(params = {}) {
    const response = await api.get('/iframe-domains', { params })
    return response.data
  },

  /**
   * Lấy chi tiết 1 domain
   * @param {number} domainId
   */
  async getDomain(domainId) {
    const response = await api.get(`/iframe-domains/${domainId}`)
    return response.data
  },

  /**
   * Tạo domain mới
   * @param {Object} data - { domain, name, description, status, allow_subdomains, ... }
   */
  async createDomain(data) {
    const response = await api.post('/iframe-domains', data)
    return response.data
  },

  /**
   * Cập nhật domain
   * @param {number} domainId
   * @param {Object} data
   */
  async updateDomain(domainId, data) {
    const response = await api.put(`/iframe-domains/${domainId}`, data)
    return response.data
  },

  /**
   * Xóa domain
   * @param {number} domainId
   */
  async deleteDomain(domainId) {
    const response = await api.delete(`/iframe-domains/${domainId}`)
    return response.data
  },

  // ============================================================
  // APPROVAL ACTIONS
  // ============================================================

  /**
   * Duyệt domain
   * @param {number} domainId
   */
  async approveDomain(domainId) {
    const response = await api.post(`/iframe-domains/${domainId}/approve`)
    return response.data
  },

  /**
   * Từ chối domain
   * @param {number} domainId
   * @param {string} reason - Lý do từ chối
   */
  async rejectDomain(domainId, reason = '') {
    const response = await api.post(`/iframe-domains/${domainId}/reject`, { reason })
    return response.data
  },

  /**
   * Tạm ngưng domain
   * @param {number} domainId
   */
  async suspendDomain(domainId) {
    const response = await api.post(`/iframe-domains/${domainId}/suspend`)
    return response.data
  },

  // ============================================================
  // PUBLIC ENDPOINTS
  // ============================================================

  /**
   * Kiểm tra domain hiện tại có được phép không (gọi từ MapPublicView)
   * Gửi domain từ document.referrer để backend validate
   * @param {string} domain - Domain cần kiểm tra (từ document.referrer)
   */
  async checkCurrentDomain(domain = null) {
    const params = {}
    if (domain) {
      params.domain = domain
    }
    const response = await api.get('/iframe-domains/check', { params })
    return response.data
  },

  /**
   * Gửi yêu cầu đăng ký domain (public form)
   * @param {Object} data - { domain, name, email, reason }
   */
  async requestAccess(data) {
    const response = await api.post('/iframe-domains/request', data)
    return response.data
  },
}

export default iframeDomainService
